import axios from 'axios';

// API_URL ist immer relativ zum Nginx Proxy
const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor für Token
api.interceptors.request.use(
  (config) => {
    try {
      const token = JSON.parse(localStorage.getItem('user') || 'null')?.token;
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch {
      // Kaputter localStorage-Eintrag: ohne Token weiter, das Backend antwortet mit 401.
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const auth = {
  register: async (username: string, password: string) => {
    const response = await api.post('/auth/register', { username, password });
    return response.data;
  },
  login: async (username: string, password: string) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  },
  // Prueft die Sitzung und liefert ein frisches Token (Sitzung verlaengert sich so beim Nutzen).
  me: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
};

export const adminApi = {
  listUsers: async (): Promise<Array<{ _id: string; username: string; isAdmin: boolean; createdAt: string | null }>> => {
    const response = await api.get('/auth/users');
    return response.data;
  },
  resetPassword: async (username: string, password?: string): Promise<{ username: string; password: string }> => {
    const response = await api.post('/auth/reset-password', { username, password });
    return response.data;
  },
};

export type IdeaStatus = 'neu' | 'vorgemerkt' | 'erledigt' | 'verworfen';
export type Idea = {
  _id: string;
  game: string;
  text: string;
  name: string;
  room: string;
  status: IdeaStatus;
  note: string;
  createdAt: string | null;
};

export const ideasApi = {
  list: async (): Promise<Idea[]> => (await api.get('/auth/ideen')).data,
  update: async (id: string, patch: { status?: IdeaStatus; note?: string }): Promise<Idea> =>
    (await api.patch(`/auth/ideen/${id}`, patch)).data,
  remove: async (id: string): Promise<void> => {
    await api.delete(`/auth/ideen/${id}`);
  },
};

export default api; 